import { render, staticRenderFns } from "./ResetCameraBtn.vue?vue&type=template&id=18b32030&scoped=true&"
import script from "./ResetCameraBtn.vue?vue&type=script&lang=ts&"
export * from "./ResetCameraBtn.vue?vue&type=script&lang=ts&"
import style0 from "./ResetCameraBtn.vue?vue&type=style&index=0&id=18b32030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b32030",
  null
  
)

export default component.exports